/* eslint-disable react-native/no-inline-styles */
import * as React from "react";
import { useController, RegisterOptions } from "react-hook-form";
import { Keyboard, StyleProp, TextStyle, View } from "react-native";
import { TextInput, TouchableRipple } from "react-native-paper";
import { InputText } from "./input-text";

interface InputSelectProps {
  control: any;
  name: string;
  inputProps?: object;
  style?: StyleProp<TextStyle>;
  label: string;
  rules?: Omit<RegisterOptions, "valueAsNumber" | "valueAsDate" | "setValueAs">;
  onClick?: Function;
  isShow?: boolean;
}

export const InputSelect = (props: InputSelectProps) => {
  const { control, name, inputProps, style = {}, label, rules, onClick = () => {}, isShow = true } = props;
  const {
    field,
    fieldState: { invalid, error },
  } = useController({
    name,
    control,
    rules,
    defaultValue: "",
  });

  const onPressItem = () => {
    Keyboard.dismiss();
    onClick();
  };

  const rightMore = <TextInput.Icon size={28} name="chevron-down" onPress={onPressItem} />;

  return (
    <React.Fragment>
      <TouchableRipple style={{ display: isShow ? "flex" : "none" }} onPress={onPressItem}>
        <View pointerEvents="none">
          <InputText
            control={control}
            name={name}
            label={label}
            style={style}
            inputProps={{ ...inputProps, editable: false, right: rightMore }}
          />
        </View>
      </TouchableRipple>
    </React.Fragment>
  );
};
